/** Icon size. */
export const ICON_SIZE = {
  XXS: 12,
  XS: 16,
  SM: 20,
  MD: 24,
  LG: 28,
  XL: 32,
} as const;
